module.exports = __webpack_public_path__ + "img/TeamComic_026.ec173493.png";